module.exports = __webpack_public_path__ + "0af033c8a1a6674a918d9496ecb5b1b7.pdf";